// extracted by mini-css-extract-plugin
module.exports =  {"bookmark":"JobsBookmark-JobsBookmark-bookmark-eaf79a2d","bookmarkButton":"JobsBookmark-JobsBookmark-bookmarkButton-ffb8f4c0"};